
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/kameleoon",
      function () {
        return require("private-next-pages/destinations/kameleoon.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/kameleoon"])
      });
    }
  